import { Util } from '@finley-technologies/finley-types';

type HardcodedLineItem = { type: 'hardcoded'; name: string; value: number };
type CashBalanceLineItem = {
  type: 'cashBalance';
  name: string;
  account: string;
};
type AccrualLineItem = { type: 'accrual'; name: string; mapping: string };
export type LineItem = (
  | HardcodedLineItem
  | CashBalanceLineItem
  | AccrualLineItem
) & { tooltip?: string };

type LineItemsContainer = {
  title: string;
  type: 'lineItemsContainer';
  lineItems: LineItem[];
};

type SummaryAccrualContainer = {
  type: 'summaryAccrualContainer';
  title: string;
  account: string;
  tooltip?: string;
};

type SummaryCashContainer = {
  type: 'summaryCashContainer';
  title: string;
  amount: number;
  tooltip?: string;
};

export type SectionContainer =
  | LineItemsContainer
  | SummaryAccrualContainer
  | SummaryCashContainer;

export type DemoSectionFormat = SectionContainer[];

export const monthlySummaryDemoSections: DemoSectionFormat = [
  {
    title: 'Available Amounts',
    type: 'lineItemsContainer',
    lineItems: [
      {
        name: 'Collections',
        type: 'cashBalance',
        account: 'collections',
        tooltip: 'Amount in collections account',
      },
      {
        name: 'Holdback from Previous Period',
        type: 'hardcoded',
        value: 0,
        tooltip: 'Amount held from previous monthly reporting period',
      },
      {
        name: 'Asset Sales Proceeds',
        type: 'hardcoded',
        value: 0,
        tooltip: 'Amount proceeds after asset sales',
      },
      {
        name: 'Mid Period Release',
        type: 'hardcoded',
        value: 0,
        tooltip: 'Amount release during middle of monthly reporting period',
      },
      {
        name: 'Equity Contribution',
        type: 'hardcoded',
        value: 0,
        tooltip: 'Amount contributed to equity',
      },
      {
        name: 'Other Adjustment',
        type: 'hardcoded',
        value: 0,
        tooltip: 'All other remaining adjustments',
      },
    ],
  },
  {
    title: 'Third Party Vendors',
    type: 'lineItemsContainer',
    lineItems: [
      {
        name: 'Excluded Fees to Servicer',
        type: 'accrual',
        mapping: '', // No existing mapping
        tooltip: '$0 per month',
      },
      {
        name: 'Backup Servicing Fee',
        type: 'accrual',
        mapping: 'accruedBackupServicingFee',
        tooltip: '$0 per month',
      },
      {
        name: 'Verification Fee',
        type: 'accrual',
        mapping: 'accruedVerificationAgentFee',
        tooltip: '$2,500 fee paid monthly to verification agent',
      },
      //   {
      //     name: 'Legal Reimbursement',
      //     type: 'hardcoded',
      //     value: 0,
      //   }
    ],
  },
  {
    title: 'Facility Fees & Expenses',
    type: 'lineItemsContainer',
    lineItems: [
      {
        name: 'Protective Advances (including Accrued Interest)',
        type: 'hardcoded',
        value: 0,
        tooltip: '$0 per month',
      },
      {
        name: 'Indemnities owed to Agent or Lenders',
        type: 'hardcoded',
        value: 0,
        tooltip: '$0 per month',
      },
      {
        name: 'Administrative Agent Fee',
        type: 'accrual',
        mapping: 'accruedAdminFee',
        tooltip: '$2,500 fee paid quarterly to administrative agent',
      },
      {
        name: 'Commitment Fee',
        type: 'accrual',
        mapping: 'accruedCommitmentFee',
        tooltip: '$0 per month',
      },
      {
        name: 'Unused Fee',
        type: 'accrual',
        mapping: 'accruedUnusedInterest',
        tooltip: '0.50% fee accrued daily for unused balance',
      },
      {
        name: 'Other Accrued Fees and Expenses',
        type: 'accrual',
        mapping: 'accruedOtherFee',
        tooltip: 'Uncategorized fees and expenses',
      },
    ],
  },
  {
    title: 'Interest',
    type: 'summaryAccrualContainer',
    account: 'accruedInterest',
    tooltip: 'SOFR Term 1 Month + 10% margin accrued daily',
  },
  {
    title: 'Borrowing Base Requirement',
    type: 'summaryCashContainer',
    amount: 1250000,
  },
  {
    title: 'Servicing Fee',
    type: 'summaryAccrualContainer',
    account: 'accruedServicingFee',
  },
];

export type CashBalanceRow = { account: string; amount: number };

export const cashBalancesFeed: {
  [fullDatStr: Util.FullDateStr]: CashBalanceRow[];
} = {
  '2023-01-01': [{ account: 'collections', amount: 5981663.82 }],
  '2023-02-01': [{ account: 'collections', amount: 1783981.34 }],
  '2023-03-01': [{ account: 'collections', amount: 2424371.52 }],
  '2023-04-01': [{ account: 'collections', amount: 2988423.76 }],
  '2023-05-01': [{ account: 'collections', amount: 3529117.45 }],
  '2023-06-01': [{ account: 'collections', amount: 3137552.89 }],
  '2023-07-01': [{ account: 'collections', amount: 2573948.61 }],
  '2023-08-01': [{ account: 'collections', amount: 1243985.67 }],
};
